import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AddUpdateUI from "./AddUpdateUI.jsx";
import { getCategories } from "../../../services/CommonServices";

const AddUpdateGenre = ({ formik, relationData }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCategories());
  }, [relationData]);

  return <AddUpdateUI formik={formik} relationData={relationData} />;
};

export default AddUpdateGenre;
